import {Component} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ICellRendererParams } from "ag-grid-enterprise";
import { ICellRendererAngularComp } from "ag-grid-angular";

export type FormGroupContext = {
  createKey: (...args: any[]) => any,
  formGroup: FormGroup
}

export type InputType = CheckboxInputType | SelectInputType

export type CheckboxInputType = {
  type: 'checkbox',
  value: boolean
}

export type SelectInputType = {
  type: 'select',
  value: number
  options: SelectInputOption[]
} | {
  type: 'select_groups',
  value: number
  opt_groups: SelectInputOptGroup[]
  null_option?: boolean
  disabled?: boolean
}

export type SelectInputOptGroup = {
  label: string,
  options: SelectInputOption[]
}

export type SelectInputOption = {
  id: number,
  name: string
}


@Component({
  selector: 'app-form-cell',
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
  template: `
    @if (formGroup?.controls?.[key]) {
      <div [formGroup]="formGroup">

        @if (tValue.type=='select' || tValue.type=='select_groups') {

          <select class="bm-select" style="height: fit-content;" [formControlName]="key" [id]="key">
            @if (tValue.type=='select') {
              @for (option of selectOptions; track $index) {
                <option [ngValue]="option.id">
                  {{ option.name }}
                </option>
              }
            } @else if (tValue.type=='select_groups') {
              @for (group of selectOptGroups; track $index) {
                @if (showNullValueOption) {
                  <option [value]="null">
                    -
                  </option>
                }
                <optgroup [label]="group.label">
                  @for (option of group.options; track $index) {
                    <option [ngValue]="option.id">
                      {{ option.name }}
                    </option>
                  }
                </optgroup>
              }
            }
          </select>
        } @else if (tValue.type=='checkbox') {
          <input type="checkbox" class="bm-checkbox" [formControlName]="key">
        }
      </div>
    }
  `,
  styleUrl: './../styles/common-styles.scss'
})
export class AgGridFormCellComponent<TValue extends InputType> implements ICellRendererAngularComp {
  formGroup: FormGroup;
  key: any;
  public tValue: TValue;
  columnName: string;

  selectOptions: SelectInputOption[]
  selectOptGroups: SelectInputOptGroup[]
  showNullValueOption: boolean

  agInit(params: ICellRendererParams<any,TValue,FormGroupContext>) {
    this.columnName = params.colDef.headerName;
    this.key = params.context.createKey(params.colDef.field, params.node);
    this.tValue = params.value;

    if (this.tValue.type == 'select') {
      this.selectOptions = this.tValue.options
    } else if (this.tValue.type == 'select_groups') {
      this.selectOptGroups = this.tValue.opt_groups
      this.showNullValueOption = this.tValue.null_option
    }

    this.formGroup = params.context.formGroup;
  }

  refresh(params: ICellRendererParams<any,TValue,FormGroupContext>): boolean {
    this.formGroup = params.context.formGroup;
    this.formGroup.controls[this.key].patchValue(this.tValue);
    return true;
  }
}
